//@flow
import React from 'react';
import SnackCard from '../../SnackCard/components/Snack.react';

import type { List } from 'immutable';
import type ProductModel from '../../Stores/Products/productModel';
import type QuoteItemsCollection from '../../Stores/Quote/quoteItemsCollection';
import type CategoriesCollection from '../../Stores/MemberCategories/categoriesCollection';
import type StockCollection from '../../Stores/Stock/stockCollection';
import type CustomerModel from '../../Stores/Customer/customerModel';
import type QuoteModel from '../../Stores/Quote/quoteModel';
import type QuoteTotalsModel from '../../Stores/Quote/quoteTotalsModel';
import type ProductsCollection from '../../Stores/Products/productsCollection';
import type MembershipPlanModel from '../../Stores/Membership/membershipPlanModel';

type Props = {
  products:ProductModel[],
  productsCollection:ProductsCollection,
  stock:StockCollection,
  quote:QuoteModel,
  quoteItems:QuoteItemsCollection,
  quoteTotals:QuoteTotalsModel,
  categories:CategoriesCollection,
  customer?:CustomerModel,
  stockReminders?:List<string>,
  userCountry?:string,
  hidePrice?:boolean,
  membershipPlan:MembershipPlanModel,
  isOffice?:boolean,
};

function _getQuoteItem(product:ProductModel, props:Props) {
  const quoteItems = props.quoteItems;
  return quoteItems && quoteItems.getQuoteItemBySku(product.getSku());
}

export default function SnacksIndex(props:Props) {
  const items = props.products.map((product, idx) => {
    return (
      <SnackCard
        idx={idx}
        key={product.getId()}
        product={product}
        quote={props.quote}
        quoteItem={_getQuoteItem(product, props)}
        quoteTotals={props.quoteTotals}
        stock={props.stock}
        categories={props.categories}
        customer={props.customer}
        stockReminders={props.stockReminders}
        userCountry={props.userCountry}
        quoteItems={props.quoteItems}
        products={props.productsCollection}
        hidePrice={props.hidePrice}
        membershipPlan={props.membershipPlan}
        isOffice={props.isOffice}
      />
    );
  });

  return (
    <ul className="gallery-grid-sm-2 gallery-grid-md-3 gallery-grid-lg-2 gallery-grid-xl-3">
      {items}
    </ul>
  );
}
